import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const VyrobekVoz = {
	name: NAME,
	apiProvider,
	router,
};
